__turbopack_context__.v({
  "accent": "Typography-module-scss-module__ywhgxW__accent",
  "alignCenter": "Typography-module-scss-module__ywhgxW__alignCenter",
  "alignLeft": "Typography-module-scss-module__ywhgxW__alignLeft",
  "alignRight": "Typography-module-scss-module__ywhgxW__alignRight",
  "balance": "Typography-module-scss-module__ywhgxW__balance",
  "body": "Typography-module-scss-module__ywhgxW__body",
  "bodyLarge": "Typography-module-scss-module__ywhgxW__bodyLarge",
  "bold": "Typography-module-scss-module__ywhgxW__bold",
  "caption": "Typography-module-scss-module__ywhgxW__caption",
  "danger": "Typography-module-scss-module__ywhgxW__danger",
  "default": "Typography-module-scss-module__ywhgxW__default",
  "display": "Typography-module-scss-module__ywhgxW__display",
  "eyebrow": "Typography-module-scss-module__ywhgxW__eyebrow",
  "medium": "Typography-module-scss-module__ywhgxW__medium",
  "muted": "Typography-module-scss-module__ywhgxW__muted",
  "regular": "Typography-module-scss-module__ywhgxW__regular",
  "semibold": "Typography-module-scss-module__ywhgxW__semibold",
  "titleLarge": "Typography-module-scss-module__ywhgxW__titleLarge",
  "titleMedium": "Typography-module-scss-module__ywhgxW__titleMedium",
  "titleSmall": "Typography-module-scss-module__ywhgxW__titleSmall",
  "type": "Typography-module-scss-module__ywhgxW__type",
});
